export const getAuthenticatedAppHref = (isClient: boolean) =>
  isClient ? '/client/calendar' : '/therapist/appointments'
